
<template>
    <div>
        <flash-message></flash-message>
        <!-- Modal -->
        <div id="projectCommentModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 v-if="company_contact" class="modal-title text-lg">
                            Bid to comment: {{ company_contact.name }}
                        </h4>
                        <h4 v-else-if="sales_status" class="modal-title text-lg">
                            {{
                                projectCommentForm.sales_status ?
                                    sales_status.full_description :
                                    'Required comment for: "' + sales_status.full_description + '" Sales Status'
                            }}
                        </h4>
                        <h4 v-else class="modal-title text-lg">General Comment</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="projectCommentForm.errors.clear($event.target.name)">
                            <div class="mb-2">
<!--                                <quill-container class="ql-editor"-->
<!--                                                 id="comment"-->
<!--                                                 v-model="projectCommentForm.comment"-->
<!--                                                 :options="users"-->
<!--                                                 @mention="addMention"-->
<!--                                                 mentionFrom="name">-->
<!--                                </quill-container>-->
                                <ckeditor-container id="comment" v-model="projectCommentForm.comment" :options="users"
                                                    @mention="addMention" mentionFrom="name"></ckeditor-container>
                                <div class="text-red text-xs" v-if="projectCommentForm.errors.has('comment')">{{
                                        projectCommentForm.errors.get('comment')
                                    }}
                                </div>
                                <div class="text-red text-xs" v-if="projectCommentForm.errors.has('comment')">{{
                                        projectCommentForm.errors.get('comment')
                                    }}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button id="save-project-comment" name="save-project-comment"
                                @click.prevent="projectCommentSaved"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Save
                        </button>
                        <button v-if="projectCommentForm.id"
                                @click.prevent="removeComment(projectCommentForm)"
                                class="bg-red hover:bg-red-darker px-3 py-1 rounded-full text-white focus:outline-none md:hidden">
                            Delete
                        </button>
                    </div>
                </div>

            </div>
        </div>
        <!-- Modal -->
        <div id="newContactModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">New Contact</h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="newContactForm.errors.clear($event.target.name)">
                            <div class="mb-2 flex">
                                <div class="w-4/5">
                                    <label class="text-grey-darkest text-sm" for="new_contact_name"
                                           :class="{'text-red': newContactForm.errors.has('name')}">Name</label>
                                    <input v-model="newContactForm.name" id="new_contact_name" name="name"
                                           maxlength="64"
                                           class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                           :class="{'border-red': newContactForm.errors.has('name')}">
                                    <div class="text-red text-xs" v-if="newContactForm.errors.has('name')">{{
                                            newContactForm.errors.get('name')
                                        }}
                                    </div>
                                </div>
                                <div class="w-1/5 flex justify-center items-center">
                                    <div class="text-center cursor-pointer table mb-0"
                                         @click.prevent.stop="openNewCompanyContactModal()">
                                        <i class="fa fa-user fa-2x"></i>
                                        <i class="fa fa-plus-circle text-teal" style="margin-left: -22px"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="email"
                                       :class="{'text-red': newContactForm.errors.has('email')}">Email</label>
                                <input
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                    :class="{'border-red': newContactForm.errors.has('email')}"
                                    type="text" id="email" v-model="newContactForm.email">
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('email')">{{
                                        newContactForm.errors.get('email')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="cell"
                                       :class="{'text-red': newContactForm.errors.has('cell')}">Cell</label>
                                <input
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                    type="text" id="cell" v-model="newContactForm.cell">
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('cell')">{{
                                        newContactForm.errors.get('cell')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="new_contact_title"
                                       :class="{'text-red': newContactForm.errors.has('title')}">Title</label>
                                <input
                                    class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                    type="text" id="new_contact_title" v-model="newContactForm.title">
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('title')">{{
                                        newContactForm.errors.get('title')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="new_contact_date"
                                       :class="{'text-red': newContactForm.errors.has('date')}">Follow Up</label>
                                <div class="flex">
                                    <datetime type="datetime" id="new_contact_date" name="date"
                                              v-model="newContactForm.date" use12-hour
                                              class="w-full"
                                              :format="{ year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' }"
                                              input-class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                              @input="newContactForm.errors.clear('date')">
                                    </datetime>
                                    <button v-if="newContactForm.date" @click.prevent.stop="removeNewContactDate"
                                            class="material-icons text-grey-darkest text-xl focus:outline-none">clear
                                    </button>
                                </div>
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('date')">{{
                                        newContactForm.errors.get('date')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0"
                                       :class="{'text-red': newContactForm.errors.has('user')}">User</label>
                                <multiselect class="cursor-pointer" :options="users" v-model="newContactForm.user"
                                             :show-labels="false" @input="newContactForm.errors.clear('user')"
                                             track-by="id" label="name" value="id"></multiselect>
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('user')">{{
                                        newContactForm.errors.get('user')
                                    }}
                                </div>
                            </div>
                        </form>
                        <company-contact-modal ref="CompanyContactModal"
                                               @selected="parseContact"></company-contact-modal>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="newContactSaved"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Add
                        </button>
                        <button
                            class="bg-grey hover:bg-grey-darker px-3 py-1 rounded-full text-white focus:outline-none md:hidden">
                            Cancel
                        </button>
                    </div>
                </div>

            </div>
        </div>

        <form @keydown="form.errors.clear($event.target.name)" id="project-management-form-id">
            <div class="flex justify-between items-center text-teal hover:text-teal-dark font-base text-sm mb-4">
                <div class="flex">
                    <div v-if="projectPosition != 'first' && projectPosition != 'only'"
                         id="previous-project"
                         @click="changeProject('previous')"
                         class="px-3 flex cursor-pointer border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden mr-1">
                        <div class="flex justify-center items-center">
                            <i class="fa fa-chevron-left"></i>
                        </div>
                    </div>
                    <div @click="goBack"
                         class="py-2 px-3 flex cursor-pointer border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden mr-1">
                        Back<span class="hidden md:inline ml-1">to List</span>
                    </div>
                    <div v-if="projectPosition != 'last' && projectPosition != 'only'"
                         id="next-project"
                         @click="changeProject('next')"
                         class="px-3 flex cursor-pointer border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden">
                        <div class="flex justify-center items-center">
                            <i class="fa fa-chevron-right"></i>
                        </div>
                    </div>
                </div>

                <div>
                    <a :href="switchToFileData" dusk="pm-record-button"
                       class="hover:no-underline py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full mr-1 focus:outline-none">
                        Sales Data Record
                    </a>
                    <a v-if="canEdit" :href="`/project-management/project/${project.project_management.project_id}/resource-files`"
                       class="hover:no-underline py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav text-followup-nav hover:text-white rounded-full mr-1 focus:outline-none hidden lg:inline">
                        Documents ({{ documentsQtd }})
                    </a>
                    <button @click.prevent="destroy" v-if="canDelete"
                            class="py-2 px-3 border-1 border-red hover:border-red hover:bg-red hover:text-white text-red rounded-full focus:outline-none hidden lg:inline">
                        Delete
                    </button>
                    <button @click.prevent="saved(false)" dusk="save-project-button" v-if="canEdit"
                            class="py-2 px-3 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                        Save
                    </button>
                </div>
            </div>
            <div class="flex justify-between items-start lg:mb-4 flex-wrap flex-lg-nowrap">
                <div class="flex-col w-full lg:w-1/3">
                    <div class="rounded bg-white shadow-md mb-4">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Project Information ID-{{ project.custom_project_id ? project.custom_project_id : project.sequential_team_id }}</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div class="flex items-end">
                                <div class="mb-2 leading-tight mr-2 md:w-3/4">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('name')}" for="name">Project
                                        Name</label>
                                    <input v-model="form.name" type="text" name="name" id="name"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                           :class="{'border-red': form.errors.has('name')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('name')">{{
                                            form.errors.get('name')
                                        }}
                                    </div>
                                </div>
                            </div>

                            <div class="mb-2 leading-tight">
                                <label class="text-grey-darkest text-sm"
                                       :class="{'text-red' : form.errors.has('address')}" for="address">Address</label>
                                <input v-model="form.address" type="text" name="address" id="address"
                                       class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                       :class="{'border-red': form.errors.has('address')}">
                                <div class="text-red text-xs" v-if="form.errors.has('address')">{{
                                        form.errors.get('address')
                                    }}
                                </div>
                            </div>
                            <div class="flex">
                                <div class="mb-2 leading-tight mr-2 w-1/2">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('city')}" for="city">City</label>
                                    <input v-model="form.city" type="text" name="city" id="city"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                           :class="{'border-red': form.errors.has('city')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('city')">{{
                                            form.errors.get('city')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 leading-tight w-1/2">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('state')}" for="state">State</label>
                                    <input v-model="form.state" type="text" name="state" id="state"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                           :class="{'border-red': form.errors.has('state')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('state')">{{
                                            form.errors.get('state')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="flex">
                                <div class="mb-2 leading-tight w-1/2 pr-1">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('zip')}" for="zip">Zip</label>
                                    <input v-model="form.zip" type="text" name="zip" id="zip"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                           :class="{'border-red': form.errors.has('zip')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('zip')">{{
                                            form.errors.get('zip')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="mb-2 leading-tight">
                                <label class="text-grey-darkest text-sm"
                                       :class="{'text-red' : form.errors.has('contact_name')}" for="contact_name">Contact
                                    Name</label>
                                <input v-model="form.contact_name" type="text" name="contact_name" id="contact_name"
                                       class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                       :class="{'border-red': form.errors.has('contact_name')}">
                                <div class="text-red text-xs" v-if="form.errors.has('contact_name')">{{
                                        form.errors.get('contact_name')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2 leading-tight">
                                <label class="text-grey-darkest text-sm"
                                       :class="{'text-red' : form.errors.has('contact_email')}" for="contact_email">Email</label>
                                <div class="flex">
                                    <input v-model="form.contact_email" type="text" name="contact_email"
                                           id="contact_email"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                           :class="{'border-red': form.errors.has('contact_email')}">
                                    <div class="cursor-pointer text-center ml-3">
                                        <a :href="`mailto:${form.contact_email}${mailSubject}`" target="_blank"
                                           style="text-decoration: none !important;"
                                           class="hover:text-grey-dark material-icons text-3xl">mail</a>
                                    </div>
                                </div>
                                <div class="text-red text-xs" v-if="form.errors.has('contact_email')">{{
                                        form.errors.get('contact_email')
                                    }}
                                </div>
                            </div>
                            <div class="flex">
                                <div class="mb-2 leading-tight mr-2 w-1/2">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('contact_phone')}" for="contact_phone">Phone</label>
                                    <input v-model="form.contact_phone" type="text" name="contact_phone"
                                           v-mask="masks.v_mask_phone"
                                           id="contact_phone"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                           :class="{'border-red': form.errors.has('contact_phone')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('contact_phone')">{{
                                            form.errors.get('contact_phone')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 leading-tight w-1/2">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('contact_cell')}" for="contact_cell">Cell</label>
                                    <input v-model="form.contact_cell" type="text" name="contact_cell" id="contact_cell"
                                           v-mask="masks.v_mask_phone"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                           :class="{'border-red': form.errors.has('contact_cell')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('contact_cell')">{{
                                            form.errors.get('contact_cell')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="flex">
                                <div class="mb-2 leading-tight w-1/2 pr-1">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red' : form.errors.has('contact_fax')}"
                                           for="contact_fax">Fax</label>
                                    <input v-model="form.contact_fax" type="text" name="contact_fax" id="contact_fax"
                                           v-mask="masks.v_mask_phone"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                           :class="{'border-red': form.errors.has('contact_fax')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('contact_fax')">{{
                                            form.errors.get('contact_fax')
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="rounded bg-white shadow-md mb-4 lg:hidden md:hidden sm:hidden">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Sales Behaviors</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div v-if="form.sales_behaviors.length > 0" v-for="(item, index) in form.sales_behaviors"
                                 class="flex mb-2 inline-block">
                                <div v-if="atLeastOneHasDate" class="col-1 px-1 flex items-center">
                                    <input v-if="item.date && !item.follow_up" type="checkbox" id="" name=""
                                           true-value="1" false-value="0" class="sales-behavior-checkbox"
                                           :disabled="checked_proposal_delivered === item.id"
                                           v-model="item.completed">
                                </div>
                                <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                                       :class="atLeastOneHasDate ? 'col-5' : 'col-6'">{{ item.name }}:</label>
                                <div class="flex px-1"
                                     :class="atLeastOneHasDate ? 'col-5' : 'col-6'">
                                    <datepicker v-model="item.date"
                                                @keypress.enter.prevent="this.closeCalendar()"
                                                :ref=item.name
                                                :disabled="checked_proposal_delivered === item.id"
                                                :format="masks.date_mask"
                                                :use-utc="true"
                                                :wrapper-class="item.date && checked_proposal_delivered !== item.id ? 'fullscreen-when-on-mobile w-4/5' : 'fullscreen-when-on-mobile w-full'"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1">
                                    </datepicker>
                                    <button v-if="item.date && checked_proposal_delivered !== item.id"
                                            @click="removeDate(item.name)"
                                            class="material-icons text-grey-darkest text-xl focus:outline-none">clear
                                    </button>
                                </div>
                                <div class="text-teal cursor-pointer flex justify-center items-center col-1 px-1"
                                     @click.prevent.stop="openEmailModal(item,form.name)">
                                    <i v-if="item.date" class="fa fa-calendar"></i>
                                </div>
                            </div>
                            <div v-if="form.sales_behaviors.length === 0" class="mb-2">
                                <div class="text-grey-darkest text-sm">
                                    Your company does not currently have any sales behaviors.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="rounded bg-white shadow-md">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Cost Record Details</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('contract_date')}"
                                           for="pm_contract_date">Contract Date</label>
                                    <datepicker
                                        v-model="form.pm_contract_date"
                                        :format="masks.date_mask"
                                        id="pm_contract_date"
                                        disabled="disabled"
                                        @keypress.enter.prevent="this.closeCalendar()"
                                        wrapper-class="fullscreen-when-on-mobile w-1/2 md:w-2/3"
                                        input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1">
                                    </datepicker>
                                    <div class="text-red text-xs" v-if="form.errors.has('pm_contract_date')">{{
                                            form.errors.get('pm_contract_date')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('contract_amt')}"
                                           for="contract_amt">Contract Amount</label>
                                    <currency-input
                                        id="contract_amt"
                                        v-model="form.contract_amt"
                                        locale="us"
                                        :currency="null"
                                        class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                                        :class="{'border-red': form.errors.has('contract_amt')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('contract_amt')">{{
                                            form.errors.get('contract_amt')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('change_orders')}"
                                           for="change_orders">Changing Orders</label>
                                    <currency-input
                                        id="change_orders"
                                        v-model="form.change_orders"
                                        locale="us"
                                        :currency="null"
                                        class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                                        :class="{'border-red': form.errors.has('change_orders')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('change_orders')">{{
                                            form.errors.get('change_orders')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('new_contract_amt')}"
                                           for="new_contract_amt">New Contract Amt</label>
                                    <currency-input
                                        id="new_contract_amt"
                                        v-model="form.new_contract_amt"
                                        locale="us"
                                        :currency="null"
                                        class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                                        :class="{'border-red': form.errors.has('new_contract_amt')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('new_contract_amt')">{{
                                            form.errors.get('new_contract_amt')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('gross_margin_percentage')}"
                                           for="gross_margin_percentage">Est. Gross Margin %</label>
                                    <currency-input
                                        id="gross_margin_percentage"
                                        v-model="form.gross_margin_percentage"
                                        locale="us"
                                        :currency="null"
                                        class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                                        :class="{'border-red': form.errors.has('gross_margin_percentage')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('gross_margin_percentage')">{{
                                            form.errors.get('gross_margin_percentage')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('gross_margin_value')}"
                                           for="gross_margin_value">Est. Gross Margin $</label>
                                    <currency-input
                                        id="gross_margin_value"
                                        v-model="form.gross_margin_value"
                                        locale="us"
                                        :currency="null"
                                        class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                                        :class="{'border-red': form.errors.has('gross_margin_value')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('gross_margin_value')">{{
                                            form.errors.get('gross_margin_value')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('labor_hours')}" for="labor_hours">Est.
                                        Labor Hours</label>
                                    <currency-input
                                        id="labor_hours"
                                        v-model="form.labor_hours"
                                        locale="us"
                                        :currency="null"
                                        class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                                        :class="{'border-red': form.errors.has('labor_hours')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('labor_hours')">{{
                                            form.errors.get('labor_hours')
                                        }}
                                    </div>
                                </div>

                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('act_gross_margin_percentage')}"
                                           for="act_gross_margin_percentage">Act. Gross Margin %</label>
                                    <currency-input
                                        id="act_gross_margin_percentage"
                                        v-model="form.act_gross_margin_percentage"
                                        locale="us"
                                        :currency="null"
                                        class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                                        :class="{'border-red': form.errors.has('act_gross_margin_percentage')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('act_gross_margin_percentage')">{{
                                            form.errors.get('act_gross_margin_percentage')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('act_gross_margin_value')}"
                                           for="act_gross_margin_value">Act. Gross Margin $</label>
                                    <currency-input
                                        id="act_gross_margin_value"
                                        v-model="form.act_gross_margin_value"
                                        locale="us"
                                        :currency="null"
                                        class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                                        :class="{'border-red': form.errors.has('act_gross_margin_value')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('act_gross_margin_value')">{{
                                            form.errors.get('act_gross_margin_value')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-1 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('act_labor_hours')}" for="act_labor_hours">
                                        Act. Labor Hours
                                    </label>
                                    <currency-input
                                        id="act_labor_hours"
                                        v-model="form.act_labor_hours"
                                        locale="us"
                                        :currency="null"
                                        class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                                        :class="{'border-red': form.errors.has('act_labor_hours')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('act_labor_hours')">{{
                                            form.errors.get('act_labor_hours')
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full lg:w-1/3 lg:mx-4 my-4 my-lg-0">
                    <div class="rounded bg-white shadow-md mb-4">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Miscellaneous Information</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3">Project Stage</label>
                                    <input
                                        type="text"
                                        v-bind:value="project.project_management.project_stage ? project.project_management.project_stage.short_description : ''"
                                        class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                                        disabled
                                    >
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('project_duration_id')}"
                                           for="project_duration_id">Project Duration</label>
                                    <select name="project_duration_id" id="project_duration_id"
                                            v-model="form.project_duration_id"
                                            class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                            :class="{'border-red': form.errors.has('project_duration_id')}">
                                        <option selected></option>
                                        <option v-for="item in selects.project_duration" :value="item.id">{{
                                                item.full_description
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('project_duration_id')">{{
                                            form.errors.get('project_duration_id')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3">Est. Complete Date</label>
                                    <input
                                        type="text"
                                        v-bind:value="form.complete_date ? form.complete_date : ''"
                                        class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                                        disabled>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3">Act. Completed Date</label>
                                    <input
                                        type="text"
                                        v-bind:value="isAllCompleted ? form.actual_completed_date : ''"
                                        class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                                        disabled>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('login_date')}">PM Login Date</label>
                                    <input type="text" name="login_date" id="login_date"
                                           class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                                           :class="{'border-red': form.errors.has('login_date')}"
                                           :value="form.login_date" disabled>
                                    <div class="text-red text-xs" v-if="form.errors.has('login_date')">{{
                                            form.errors.get('login_date')
                                        }}
                                    </div>
                                </div>
                                <div :class="(form.gantt_completed)? 'col-md-11 p-0':'my-display-contents'">
                                    <div class="mb-2 ml-2 leading-tight w-full row">
                                        <label class="text-grey-darkest text-sm w-1/2" :class="(form.gantt_completed)? 'width-36':'md:w-1/3'">Project Start
                                            Date</label>
                                        <datepicker v-model="form.production_start_date"
                                                    :format="masks.date_mask"
                                                    :disabled="form.gantt_completed"
                                                    @keypress.enter.prevent="this.closeCalendar()"
                                                    wrapper-class="fullscreen-when-on-mobile w-1/2"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                                    :class="(form.gantt_completed)? ' md:w-3/5':' md:w-2/3'"
                                        >
                                        </datepicker>
                                    </div>
                                    <div class="mb-2 ml-2 leading-tight w-full row">
                                        <label class="text-grey-darkest text-sm w-1/2" :class="(form.gantt_completed)? 'width-36':'md:w-1/3'">Project End Date</label>
                                        <datepicker v-model="form.production_end_date"
                                                    :format="masks.date_mask"
                                                    :disabled="form.gantt_completed"
                                                    @keypress.enter.prevent="this.closeCalendar()"
                                                    wrapper-class="fullscreen-when-on-mobile w-1/2"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                                    :class="(form.gantt_completed)? ' md:w-3/5':' md:w-2/3'"
                                        >
                                        </datepicker>
                                    </div>
                                </div>
                                <div :class="(form.gantt_completed)? 'col-md-1 p-0 float-right my-unlock-button-dates cursor-pointer':'d-none'" @click="uploadProjectStartEndDate()">
                                    <i class="fa fa-lock" style="color: rgb(243, 89, 89);"></i>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('project_manager_id')}"
                                           for="project_manager_id">Project Manager</label>
                                    <select name="project_manager_id" id="project_manager_id"
                                            v-model="form.project_manager_id"
                                            class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                            :class="{'border-red': form.errors.has('project_manager_id')}">
                                        <option selected></option>
                                        <option v-for="item in selects.users" :value="item.id">{{
                                                item.name
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('project_manager_id')">{{
                                            form.errors.get('project_manager_id')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('project_engineer_id')}"
                                           for="project_engineer_id">Project Engineer</label>
                                    <select name="project_engineer_id" id="project_engineer_id"
                                            v-model="form.project_engineer_id"
                                            class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                            :class="{'border-red': form.errors.has('project_engineer_id')}">
                                        <option selected></option>
                                        <option v-for="item in selects.users" :value="item.id">{{
                                                item.name
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('project_engineer_id')">{{
                                            form.errors.get('project_engineer_id')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('project_admin_id')}"
                                           for="project_admin_id">Project Admin</label>
                                    <select name="project_admin_id" id="project_admin_id"
                                            v-model="form.project_admin_id"
                                            class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                            :class="{'border-red': form.errors.has('project_admin_id')}">
                                        <option selected></option>
                                        <option v-for="item in selects.users" :value="item.id">{{
                                                item.name
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('project_admin_id')">{{
                                            form.errors.get('project_admin_id')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('superintendent_id')}"
                                           for="superintendent_id">Superintendent</label>
                                    <select name="superintendent_id" id="superintendent_id"
                                            v-model="form.superintendent_id"
                                            class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                            :class="{'border-red': form.errors.has('superintendent_id')}">
                                        <option selected></option>
                                        <option v-for="item in selects.users" :value="item.id">{{
                                                item.name
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('superintendent_id')">{{
                                            form.errors.get('superintendent_id')
                                        }}
                                    </div>
                                </div>
                                <div v-for="(crew_leader, index) in form.crew_leaders" :key="index">
                                    <div class="mb-2 ml-2 leading-tight w-full row">
                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                               :class="{'text-red' : form.errors.has('crew_leader_id')}"
                                               :for="'crew_leaders_' + index">Crew / Sub</label>
                                        <select :name="'crew_leader[' + index + ']'" :id="'crew_leaders_' + index"
                                                v-model="crew_leader.user_id"
                                                class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-3/5"
                                                :class="{'border-red': form.errors.has('crew_leader_id')}">
                                            <option selected value="0"></option>
                                            <option v-for="item in selects.users" :value="item.id">{{
                                                    item.name
                                                }}
                                            </option>
                                        </select>
                                        <button v-if="index === 0" class="shadow-none btn btn-sm p-1 ml-1"
                                                @click.prevent="addCrewLeader"><i class="fa fa-plus"></i></button>
                                        <button v-else class="shadow-none btn btn-sm p-1 ml-1"
                                                @click.prevent="removeCrewLeader(index)"><i class="fa fa-minus"></i>
                                        </button>
                                        <div class="text-red text-xs" v-if="form.errors.has('crew_leader_id')">{{
                                                form.errors.get('crew_leader_id')
                                            }}
                                        </div>
                                    </div>
                                    <div class="mb-2 ml-2 leading-tight w-full row">
                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3">CL Start
                                            Date</label>
                                        <datepicker v-model="crew_leader.start_date"
                                                    :format="masks.date_mask"
                                                    :disabled="form.gantt_completed"
                                                    @keypress.enter.prevent="this.closeCalendar()"
                                                    wrapper-class="fullscreen-when-on-mobile w-1/2 md:w-2/3"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                        >
                                        </datepicker>
                                        <label class="text-grey-darkest text-sm w-1/2 md:w-1/3">CL End
                                            Date</label>
                                        <datepicker v-model="crew_leader.end_date"
                                                    :format="masks.date_mask"
                                                    :disabled="form.gantt_completed"
                                                    @keypress.enter.prevent="this.closeCalendar()"
                                                    wrapper-class="fullscreen-when-on-mobile w-1/2 md:w-2/3"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                        >
                                        </datepicker>
                                    </div>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('products_and_services_id')}"
                                           for="products_and_services_id">{{ getFieldLabel(fieldLabels, 'products-and-services')}}</label>
                                    <select name="products_and_services_id" id="products_and_services_id"
                                            v-model="form.products_and_services_id"
                                            class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                            :class="{'border-red': form.errors.has('products_and_services_id')}">
                                        <option selected></option>
                                        <option v-for="item in selects.products_and_services" :value="item.id">{{
                                                item.full_description
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('products_and_services_id')">{{
                                            form.errors.get('products_and_services_id')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('client_profile_id')}"
                                           for="client_profile_id">{{ getFieldLabel(fieldLabels,'client-profile')}}</label>
                                    <select name="client_profile_id" id="client_profile_id"
                                            v-model="form.client_profile_id"
                                            class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                            :class="{'border-red': form.errors.has('client_profile_id')}">
                                        <option selected></option>
                                        <option v-for="item in selects.client_profile" :value="item.id">{{
                                                item.full_description
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('client_profile_id')">{{
                                            form.errors.get('client_profile_id')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('contract_type_id')}"
                                           for="contract_type_id">{{ getFieldLabel(fieldLabels, 'contract-type')}}</label>
                                    <select name="contract_type_id" id="contract_type_id"
                                            v-model="form.contract_type_id"
                                            class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                            :class="{'border-red': form.errors.has('contract_type_id')}">
                                        <option selected></option>
                                        <option v-for="item in selects.contract_type" :value="item.id">
                                            {{
                                                item.full_description
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('contract_type_id')">{{
                                            form.errors.get('contract_type_id')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                           :class="{'text-red' : form.errors.has('office_id')}"
                                           for="office_id">{{ getFieldLabel(fieldLabels, 'office')}}</label>
                                    <select name="office_id" id="office_id"
                                            v-model="form.office_id"
                                            class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-1/2 md:w-2/3"
                                            :class="{'border-red': form.errors.has('office_id')}">
                                        <option selected></option>
                                        <option v-for="item in selects.office" :value="item.id">{{
                                                item.full_description
                                            }}
                                        </option>
                                    </select>
                                    <div class="text-red text-xs" v-if="form.errors.has('office_id')">{{
                                            form.errors.get('office_id')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div>
                                <project-custom-fields ref="CustomFields" :project="project" :masks="masks" :team="team"></project-custom-fields>
                            </div>
                        </div>
                    </div>
                    <div class="rounded bg-white shadow-md">
                        <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                            <span>Project Management Behavior Hours</span>
                        </div>
                        <div class="pt-4 pb-2 px-3">
                            <div v-if="behavior_hours_loading">
                                Loading...
                            </div>
                            <div class="flex flex-wrap" v-else>
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <table class="small">
                                        <tr class="">
                                            <td></td>
                                            <td>Estimated</td>
                                            <td>Actual</td>
                                        </tr>
                                        <tr v-for="stage in behavior_hours">
                                            <td class="whitespace-no-wrap">{{ stage.project_stage }}</td>
                                            <td>
                                                <input
                                                    type="text"
                                                    class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                                                    :value="stage.estimated"
                                                    disabled
                                                >
                                            </td>
                                            <td>
                                                <input v-if="stage.actual !== null"
                                                       type="text"
                                                       class="rounded p-1 text-grey-darkest text-sm focus:outline-none border-1 w-1/2 md:w-2/3"
                                                       :value="stage.actual"
                                                       disabled
                                                >
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rounded bg-white shadow-md w-full lg:w-1/3 lg:mx-4 my-4 my-lg-0">
                    <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                        <span>Project Management Behaviors</span>
                    </div>

                    <div class="pt-4 pb-2 px-3">
                        <div class="accordion" id="accordionManagementBehaviors">
                            <div class="card" style="overflow: inherit" v-if="form.pm_behaviors.length > 0"
                                 v-for="(item, index) in form.pm_behaviors" :key="index">
                                <div class="card-header" v-bind:id="'heading' + index">
                                    <h2 class="mb-0">
                                        <button class="btn btn-link" type="button" data-toggle="collapse"
                                                v-bind:data-target="'#collapse' + index" aria-expanded="true"
                                                v-bind:aria-controls="'collapse' + index">
                                            {{ item.full_description }}
                                        </button>
                                    </h2>
                                </div>
                                <div
                                    v-bind:id="'collapse' + index"
                                    class="collapse"
                                    v-bind:class="{show: project.project_management.project_stage && item.id == project.project_management.project_stage.id}"
                                    v-bind:aria-labelledby="'heading' + index"
                                    data-parent="#accordionManagementBehaviors"
                                >
                                    <div class="card-body">
                                        <ul class="list-group">
                                            <li class="list-group-item"
                                                v-for="(constructionBehavior, constructionIndex) in item.project_management_behaviors">
                                                <div class="form-group form-check pl-0 mb-1">
                                                    <input
                                                        type="checkbox"
                                                        v-model="constructionBehavior.completed"
                                                        :disabled="(constructionBehavior.already_completed === 1 && constructionBehavior.unlock_activity === 0) || constructionBehavior.not_available === 1"
                                                    >
                                                    <label class="form-check-label">
                                                        {{ constructionBehavior.name }}
                                                    </label>
                                                    <div class="float-right">
                                                        <i v-if="constructionBehavior.unlock_activity === 1" class="fa fa-unlock-alt " style="color: #14b1af;" aria-hidden="true"></i>
                                                        <i v-else class="fa fa-lock" style="color: #f35959;" aria-hidden="true"></i>
                                                        <span v-if="constructionBehavior.already_completed === 0 && constructionBehavior.date && constructionBehavior.not_available === 0"
                                                              style="color: #2c72bb;font-size: 14px;cursor: pointer;" @click="saveNotAvailable(constructionBehavior)">N/A</span>
                                                        <span v-else
                                                              style="color: rgb(209 209 212);font-size: 14px;">N/A</span>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6 d-flex align-items-center">
                                                        <datepicker v-model="constructionBehavior.date"
                                                                    :ref="constructionBehavior.name"
                                                                    format="MM/dd/yyyy"
                                                                    :typeable="false"
                                                                    @input="changeBehaviorDate(constructionBehavior.date = fixDate($event),constructionBehavior.project_stage_id,constructionBehavior.load_order,index)"
                                                                    @keypress.enter.prevent="this.closeCalendar()"
                                                                    :wrapper-class="atLeastOneHasDate ? 'w-5/6 fullscreen-when-on-mobile' : 'w-full fullscreen-when-on-mobile '"
                                                                    input-class="cursor-pointer rounded w-full p-1 text-sm focus:outline-none border-1"
                                                                    v-bind:disabled="(constructionBehavior.already_completed === 1 && constructionBehavior.unlock_activity === 0) || constructionBehavior.not_available === 1"

                                                        >
                                                        </datepicker>
                                                        <button  type="button" v-if="constructionBehavior.date && constructionBehavior.not_available === 0 && ((constructionBehavior.already_completed === 0 && constructionBehavior.unlock_activity === 0) || (constructionBehavior.already_completed === 1 && constructionBehavior.unlock_activity === 1))" @click="() => {constructionBehavior.date = null; constructionBehavior.userObj = null;}"
                                                                 class="material-icons text-grey-darkest text-xl focus:outline-none ml-1">clear
                                                        </button>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <multiselect
                                                            :options="pm_users"
                                                            v-model="constructionBehavior.userObj"
                                                            :show-labels="false"
                                                            track-by="id"
                                                            :group-select="false"
                                                            label="name"
                                                            :multiple="false"
                                                            @remove="removeUserFromConstructionBehavior(constructionIndex, index)"
                                                            class="mb-2 cursor-pointer">
                                                        </multiselect>
<!--                                                        <select-->
<!--                                                            name="assigned_to"-->
<!--                                                            v-model="constructionBehavior.user_id"-->
<!--                                                            class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm"-->
<!--                                                            v-bind:disabled="(constructionBehavior.already_completed === 1 && constructionBehavior.unlock_activity === 0) || constructionBehavior.not_available === 1"-->
<!--                                                        >-->
<!--                                                            <option :value="null"></option>-->
<!--                                                            <option v-for="user in selects.pm_users" :value="user.id">-->
<!--                                                                {{ user.name }}-->
<!--                                                            </option>-->
<!--                                                        </select>-->
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div v-if="fetching_stages" class="mb-2">
                                Loading
                            </div>
                            <div v-if="!fetching_stages && form.pm_behaviors.length === 0" class="mb-2">
                                <div class="text-grey-darkest text-sm">
                                    Your company does not currently have any project management behaviors.
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="rounded bg-white shadow-md mb-4">
                <external-email-section :project="project" :email="form.contact_email" :exchange="exchange" :canEdit="canEdit" :allContacts="[]"
                                        @refresh-comments="fetchComments()"  :hasSequencesAccess="0"></external-email-section>
            </div>

            <div class="rounded bg-white shadow-md mb-4">
                <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                    <span>Company Information</span>
                </div>
                <div class="py-4 px-3 flex flex-wrap flex-lg-nowrap items-stretch ">
                    <div class="flex-col w-full lg:w-1/3 pr-4">
                        <div class="mb-1 text-grey-darkest text-sm">To add a contact, first pick a company</div>
                        <div class="mb-4 leading-tight">
                            <multiselect
                                id="companies"
                                v-model="selectedCompany"
                                @input="fetchContacts"
                                :options="allCompanies"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="false"
                                :taggable="true"
                                open-direction="below"
                                placeholder="Pick a company"
                                tag-placeholder="Add this company"
                                :showLabels="false"
                                label="name"
                                track-by="id"
                                @tag="openCompanyCreateModal"
                                :preselect-first="false">
                            </multiselect>
                        </div>
                        <div v-if="contacts.length > 0">
                            <div class="flex justify-content-between pb-4">
                                <div class="mb-1 text-grey-darkest text-sm">Now add contacts to the current project
                                </div>
                                <button @click.prevent.stop="addNewContact()" :disabled="!canEdit"
                                        class="cursor-pointer border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:text-white p-2 rounded-full text-base text-followup-nav">
                                    New Contact
                                </button>
                            </div>

                            <div class="leading-tight">
                                <div @click.prevent.stop="addOrRemoveContact(contact)" v-for="contact in contacts"
                                     class="p-2 hover:bg-grey-lighter flex justify-between items-center rounded cursor-pointer">
                                    <div class="flex-col items-baseline">
                                        <div class="font-medium mr-3 text-base text-grey-darkest">{{ contact.name }}
                                        </div>
                                        <div class="text-sm text-grey-darkest">{{ contact.cell }}</div>
                                    </div>
                                    <button v-if="!contactAddedAlready(contact)"
                                            @click.prevent.stop="addOrRemoveContact(contact)" :disabled="!canEdit"
                                            class="cursor-pointer border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:text-white material-icons p-1 rounded-full text-base text-followup-nav">
                                        add
                                    </button>
                                    <span v-else @click.prevent.stop="addOrRemoveContact(contact)" :disabled="!canEdit"
                                          class="cursor-pointer border-2 border-red focus:outline-none font-semibold hover:bg-red hover:text-white material-icons p-1 rounded-full text-base text-red">
                                        close
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="hidden lg:flex border-1 border-grey mr-4"></div>
                    <div class="flex-1">
                        <hr class="lg:hidden">
                        <table class="w-full">
                            <thead>
                            <tr>
                                <th class="pb-2 pl-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light">
                                    Company Name
                                </th>
                                <th class="pb-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light">
                                    Contact Name
                                </th>
                                <th class="pb-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                                    Email/Phone
                                </th>
                                <th class="pb-2 font-medium uppercase text-xs text-grey-darkest border-b border-grey-light hidden xl:table-cell">
                                    Follow Up
                                </th>
                                <th class="pb-2 hidden xl:table-cell"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(contact, index) in form.company_contacts"
                                class="hover:bg-grey-lighter rounded hidden xl:table-row">
                                <td class="pl-2 text-sm text-grey-darkest cursor-pointer"
                                    @click.prevent.stop="goToCompany(contact.company)">{{ contact.company.name }}
                                </td>
                                <td class="text-sm text-grey-darkest cursor-pointer"
                                    @click.prevent.stop="goToCompany(contact.company)">
                                    {{ contact.name }}, {{ contact.title }}
                                </td>
                                <td class="text-sm font-light text-grey-darkest">
                                    <div class="flex-col">
                                        <div><a :href="`mailto:${contact.email}${mailSubject}`"
                                                class="text-grey-darkest hover:text-grey-darkest">{{
                                                contact.email
                                            }}</a></div>
                                        <div><a :href="`tel:${contact.cell}`"
                                                class="text-grey-darkest hover:text-grey-darkest">{{
                                                contact.cell
                                            }}</a></div>
                                    </div>
                                </td>
                                <td class="text-sm text-grey-darkest flex pt-2 text-sm">
                                    <datetime type="datetime" id="date" name="date" v-model="contact.date" use12-hour
                                              :format="{ year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' }"
                                              :week-start="7"
                                              input-class="bg-white leading-normal mt-2 tracking-wide shadow-sm appearance-none border rounded px-2 text-grey-darkest w-full focus:outline-none">
                                    </datetime>
                                    <button type="button" v-if="contact.date" @click.prevent.stop="removeMeeting(index)"
                                            class="material-icons text-grey-darkest text-xl focus:outline-none mt-2">
                                        clear
                                    </button>
                                </td>

                                <td class="pt-2">
                                    <button @click.prevent.stop="addComment(contact)" :disabled="!canEdit"
                                            class="focus:outline-none text-base font-light text-grey-darkest hover:text-grey-darkest material-icons">
                                        add_comment
                                    </button>
                                    <button @click.prevent.stop="addOrRemoveContact(contact)" :disabled="!canEdit"
                                            class="focus:outline-none text-base font-light text-grey-darkest hover:text-grey-darkest material-icons">
                                        delete
                                    </button>
                                </td>
                            </tr>
                            <tr v-for="(contact, index) in form.company_contacts"
                                class="hover:bg-grey-lighter rounded xl:hidden"
                                @click="openCompanyContactModal(contact, index)">
                                <td class="pl-2 text-sm text-grey-darkest cursor-pointer">
                                    {{ contact.company.name }}
                                </td>
                                <td class="text-sm text-grey-darkest cursor-pointer">
                                    {{ contact.name }}, {{ contact.title }}
                                </td>
                                <td class="text-sm text-grey-darkest cursor-pointer hidden lg:table-cell">
                                    {{ contact.email }} | {{ contact.cell }}
                                </td>
                            </tr>
                            <company-contact-details ref="companyContactModal" :project="project"
                                                     @save="saveContactData"
                                                     @destroy="addOrRemoveContact">
                            </company-contact-details>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>


        </form>
        <project-comments ref="projectcomments" :project="project" :isAdmin="isAdmin" :canEdit="canEdit" :user="spark.state.user" :isPM="true" ></project-comments>
        <external-email-file-modal ref="EmailFileModal"></external-email-file-modal>
        <project-contact-modal :exchange="exchange" ref="EmailContactModal"></project-contact-modal>
        <company-create-modal ref="CompanyCreateModal" @inserted="fetchCompanies"></company-create-modal>
    </div>
</template>

<script>
import Form            from "../../utils/form";
import Datepicker      from 'vuejs-datepicker';
import Multiselect     from 'vue-multiselect';
import {CurrencyInput} from 'vue-currency-input';
import VueTribute      from 'vue-tribute';
import QuillContainer  from '../shared/quill-container';
import {specialCharacterCodeConstants} from '../constants/constants.js';

export default {
    name : 'project-edit',
    props: [
        'masks',
        'isAllCompleted',
        'company',
        'project',
        'userLegacy',
        'dashboard',
        'reportCard',
        'isAdmin',
        'canEdit',
        'updated',
        'reference',
        'documentsQtd',
        'exchange',
        'fieldLabels',
        'team',
        'canDelete'
    ],

    components: {Datepicker, Multiselect, CurrencyInput, VueTribute, QuillContainer, specialCharacterCodeConstants},

    data() {
        return {
            behavior_hours_loading    : true,
            behavior_hours            : [],
            fetching_stages           : true,
            allCompanies              : [],
            contacts                  : [],
            users                     : [],
            selectedCompany           : null,
            options                   : {
                format    : this.moment_mask,
                useCurrent: false,
            },
            vueTributeOptions         : {
                values     : (text, cb) => {
                    this.filterUsers(text, cb);
                },
                allowSpaces: true,
                lookup     : 'name',
                fillAttr   : 'name',
                selectClass: 'selected-mention'
            },
            page                  : 1,
            pagination            : {
                data : [],
                meta : {},
                links: {},
            },
            project_comments          : [],
            selects                   : {},
            pm_users                  : [],
            form                      : new Form({
                company_contacts        : this.project.company_contacts,
                name                    : this.project.name,
                bid_bond                : this.project.bid_bond || false,
                address                 : this.project.address,
                city                    : this.project.city,
                state                   : this.project.state,
                zip                     : this.project.zip,
                contact_name            : this.project.contact ? this.project.contact.name : '',
                contact_email           : this.project.contact ? this.project.contact.email : '',
                contact_phone           : this.project.contact && this.project.contact.phone ? this.project.contact.phone.replace(/\D/g, '') : '',
                contact_cell            : this.project.contact && this.project.contact.cell ? this.project.contact.cell.replace(/\D/g, '') : '',
                contact_fax             : this.project.contact && this.project.contact.fax ? this.project.contact.fax.replace(/\D/g, '') : '',
                relate_and_connect_id   : this.project.relate_and_connect,
                rules_of_engagement_id  : this.project.rules_of_engagement,
                find_problems_id        : this.project.find_problems,
                money_step_id           : this.project.money_step,
                decision_process_id     : this.project.decision_process,
                base_bid                : this.project.base_bid ? Number(this.project.base_bid.split(',').join('')) : null,
                contract_amt            : this.project.project_management.contract_amt ? Number(this.project.project_management.contract_amt.split(',').join('')) : null,
                contract_date           : this.project.contract_date,
                gross_margin_percentage : this.project.project_management.gross_margin_percentage ? Number(this.project.project_management.gross_margin_percentage.split(',').join('')) : null,
                labor_hours             : this.project.project_management.labor_hours ? Number(this.project.project_management.labor_hours.split(',').join(''))  : null,
                sales_status_id         : this.project.sales_status,
                marketing_status_id     : this.project.marketing_status,
                project_manager_id      : this.project.project_management.project_manager_id,
                project_engineer_id     : this.project.project_management.project_engineer_id,
                project_admin_id        : this.project.project_management.project_admin_id,
                superintendent_id       : this.project.project_management.superintendent_id,
                crew_leader_id          : this.project.project_management.crew_leader_id,
                crew_leaders            : this.project.project_management.crew_leaders.length > 0 ? this.project.project_management.crew_leaders : [
                    {
                        user_id   : 0,
                        start_date: null,
                        end_date  : null
                    }
                ],
                pre_bid                 : this.project.pre_bid,
                bid_date                : this.project.bid_date,
                created_at              : this.project.created_at,
                dead_date               : this.project.dead_date,
                lead_from_id            : this.project.lead_from,
                estimator_id            : this.project.estimator,
                account_manager_id      : this.project.account_manager,
                take_off_person_id      : this.project.take_off_person,
                products_and_services_id: this.project.products_and_services,
                client_profile_id       : this.project.client_profile,
                contract_type_id        : this.project.contract_type,
                office_id               : this.project.office,
                sales_behaviors         : this.project.sales_behaviors.map(sb => {
                    return {...sb, date: sb.date ? moment(sb.date).format('YYYY-MM-DD') : ''}
                }),
                pm_behaviors            : [],
                login_date              : moment(this.project.project_management.login_date).format(this.masks.moment_mask),
                complete_date           : moment(this.project.project_management.complete_date).format(this.masks.moment_mask),
                actual_completed_date   : this.project.project_management.actual_completed_date ? moment(this.project.project_management.actual_completed_date).format(this.masks.moment_mask) : moment(this.project.project_management.complete_date).format(this.masks.moment_mask),
                pm_contract_date        : moment(this.project.project_management.pm_contract_date).format(this.masks.moment_mask),
                project_duration_id     : this.project.project_management.project_duration_id,
                change_orders           : this.project.project_management.change_orders ? Number(this.project.project_management.change_orders.split(',').join('')) : null,
                new_contract_amt        : this.project.project_management.new_contract_amt ? Number(this.project.project_management.new_contract_amt.split(',').join('')) : null,
                gross_margin_value      : this.project.project_management.gross_margin_value ? Number(this.project.project_management.gross_margin_value.split(',').join('')) : null,
                production_start_date   : this.project.project_management.production_start_date,
                production_end_date     : this.project.project_management.production_end_date,
                gantt_completed         : (this.project.project_management.gantt_completed === 1) ? true: false,
                act_gross_margin_percentage : this.project.project_management.act_gross_margin_percentage ? Number(this.project.project_management.act_gross_margin_percentage.split(',').join('')) : null,
                act_gross_margin_value      : this.project.project_management.act_gross_margin_value ? Number(this.project.project_management.act_gross_margin_value.split(',').join('')) : null,
                act_labor_hours             : this.project.project_management.act_labor_hours ? Number(this.project.project_management.act_labor_hours.split(',').join(''))  : null,
            }),
            editing                   : false,
            current_comment           : null,
            company_contact           : null,
            sales_status              : null,
            projectCommentForm        : new Form({
                id                : null,
                comment           : '',
                date              : '',
                company_contact_id: null,
                sales_status_id   : null,
                mentioned_users   : []
            }),
            newContactForm            : new Form({
                id       : null,
                name     : '',
                email    : '',
                cell     : '',
                title    : '',
                date     : null,
                completed: null,
                user     : null,
            }),
            checked_proposal_delivered: false,
            storage_project_list      : {
                list         : [],
                current_index: -1
            },
            existPmBehaviors          : false,
            project_management_id     : this.project.project_management.id,
            specialCharacterCode: specialCharacterCodeConstants,
        }
    },

    watch: {
        'form.project_engineer_id': function (value) {
            this.changeUserBehavior(value, 'project_engineer_id');
        },
        'form.project_manager_id' : function (value) {
            this.changeUserBehavior(value, 'project_manager_id');
        },
        'form.project_admin_id'   : function (value) {
            this.changeUserBehavior(value, 'project_admin_id');
        },
        'form.superintendent_id'  : function (value) {
            this.changeUserBehavior(value, 'superintendent_id');
        },
        'form.crew_leader_id'     : function (value) {
            this.changeUserBehavior(value, 'crew_leader_id');
        },
        'form.contract_type_id'   : function () {
            this.fetchStagesByContractType();
        },
        // 'form.pm_contract_date'   : function (value) {
        //     this.updateStepDate(value);
        // },
        'form.project_duration_id': function (value) {
            this.updateStepDate(this.form.pm_contract_date);
        },
    },

    created() {
        this.fetchCompanies();
        this.fetchCodes();
        this.fetchTeamUsers();
        this.fetchDurations();
        this.findActiveProposalDelivered();
        this.getLocalCurrentListData();
        this.fetchComments();
        this.fetchStages();
        this.fetchBehaviorHours();
    },

    mounted() {
        let self = this;
        $("#projectCommentModal").on('hidden.bs.modal', function () {
            self.projectCommentForm.reset();
            self.company_contact                 = null;
            self.sales_status                    = null;
            self.projectCommentForm.sales_status = null;
            self.editing                         = false;
        });
    },

    computed: {
        atLeastOneHasDate() {
            return _.some(this.form.sales_behaviors, (item) => item.date);
        },

        mailSubject() {
            let projectNameSplit = this.project.name.split('');
            let nameArray = [];
            this.specialCharacterCode.forEach(character => {
                projectNameSplit.forEach((item, index) => {
                    if(item == character.character){
                        nameArray.push({index: index, code: character.code});
                    }
                });
            });
            projectNameSplit.forEach((item, index) => {
                nameArray.forEach((character, ind) => {
                    if(index == character.index){
                        projectNameSplit[index] = character.code;
                    }
                })
            });

            let projName = projectNameSplit.join("");
            return `?subject=(${projName} - ${this.project.id})`;
        },

        projectPosition() {
            const isFirst = this.storage_project_list.current_index === 0;
            const isLast  = this.storage_project_list.current_index === this.storage_project_list.list.length - 1;

            if (isFirst && isLast) return 'only';
            if (isFirst && !isLast) return 'first';
            if (isLast && !isFirst) return 'last';
            return null;
        },

        switchToFileData() {
            return route('api.user-mode', {
                'path'        : `project/edit`,
                'isManagement': 0,
                'projectId'   : this.project.project_management.project_id
            });

        }
    },

    methods: {
        saveNotAvailable(Behavior){
            const Toast = Swal.mixin({
                toast            : true,
                position         : 'top-end',
                showConfirmButton: false,
                timer            : 2000
            });
            let self = this;

            let data = {
                'project_management_behavior_id':Behavior.id,
                'user_id':Behavior.user_id,
                'project_management_id':self.project.project_management.id
            }
            axios.put(route('api.project-management.update-not-available', {data: data})).then((res) => {
                Toast.fire({
                    type : 'success',
                    title: 'Project Management Behaviors Set Not available'
                });

                setTimeout(() => {
                    window.location = route('project-management.project.edit', {projectManagement: self.project.id});
                }, 2000);
            }).catch(error => {
                this.flash(error.message, 'error');
            });
        },
        pmContractDateSelect(date) {
            this.form.pm_contract_date = moment(date).format('YYYY-MM-DD');
        },

        pmBehaviorsExistInContractType(contractTypeId) {
            axios.get(route('project-management.api.settings.project-management-behavior.verify-exist-by-contract-type_id', [contractTypeId]))
                .then(({data}) => {
                    this.existPmBehaviors = data > 0;
                });
        },

        fetchStages() {
            let self             = this;
            this.fetching_stages = true;
            axios.get(route('project-management.api.settings.codes.project-stage.project-management-filter', [self.project_management_id]))
                .then(({data}) => {
                    let projectStages = data;

                    /*
                    * filtering fetched pm behaviors from fetched stages
                    * which belongs to current project management
                    *  */

                    projectStages.map(function (stage) {
                        return stage.project_management_behaviors.map(function (behavior) {
                            let filteredBehaviors = _.filter(self.project.project_behaviors, {id: behavior.id});
                            if (filteredBehaviors.length > 0) {
                                behavior.not_available           = filteredBehaviors[0].pivot.not_available;
                                behavior.user_id           = filteredBehaviors[0].pivot.user_id;
                                behavior.completed         = filteredBehaviors[0].pivot.completed;
                                behavior.already_completed = filteredBehaviors[0].pivot.completed;
                                behavior.date              = (filteredBehaviors[0].pivot.date) ? moment(filteredBehaviors[0].pivot.date).utc(1).format('MM/DD/YYYY') : null;
                                behavior.userObj = {
                                    id: filteredBehaviors[0].pivot.user_id,
                                    name:filteredBehaviors[0].user_name ?? null
                                };
                            } else {
                                behavior.user_id = null;
                                behavior.date    = null;
                                behavior.not_available    = 0;
                                behavior.user = {};
                            }
                            return behavior;
                        });
                    });
                    let pmStages = [];

                    /*
                    * Loop on PM stages
                    * Step 1 Checking if project has contract type selected
                    * Step 2 then filter pm behaviors with contract_type_id same as project
                    * Step 3 if filtered pm behaviors length is 0 then filter pm behaviors with no contract_type_id
                    * Step 4 if project has no contract type selected
                    * Step 5 then filter all pm behaviors with no contract type id
                    * */

                    if(this.form.contract_type_id != null) {
                        pmStages = projectStages.map((stage)=>{
                            let stageBehaviours = stage.project_management_behaviors.filter((behaviour) => {
                                if(behaviour.contract_type_id === this.form.contract_type_id){
                                    return behaviour
                                }
                            })
                            if(stageBehaviours.length === 0) {
                                stageBehaviours = stage.project_management_behaviors.filter((behaviour) => {
                                    if(behaviour.contract_type_id == null){
                                        return behaviour
                                    }
                                })
                            }
                            stage.project_management_behaviors = stageBehaviours
                            return stage;
                        })
                    }else{
                        pmStages = projectStages.map((stage)=>{
                            let behaviors = stage.project_management_behaviors.filter((behaviour) => {
                                if(behaviour.contract_type_id == null){
                                    return behaviour
                                }
                            })
                            stage.project_management_behaviors = behaviors
                            return stage;
                        })
                    }

                    this.form.pm_behaviors = pmStages;
                    this.fetching_stages   = false;
                    // this.updateStepDate(this.form.pm_contract_date);
                });
        },
        changeBehaviorDate(date, stageId, loadOrder, stageIndexInput){
            const self = this;

            let lastDate = moment(date);
            let difference = 0;
            let allBehaviors = [];

            let previousDuration = 0;
            self.form.pm_behaviors = _.map(self.form.pm_behaviors, (stage, stageIndex) => {
                allBehaviors = _.concat(allBehaviors, stage.project_management_behaviors);
                if(stageIndex >= stageIndexInput) {

                    stage.project_management_behaviors = _.map(stage.project_management_behaviors, (behavior) => {

                        const duration = (self.form.project_duration_id) ? _.find(behavior.project_durations, x => x.id === self.form.project_duration_id) : null;

                        if(duration && date) {
                            difference = duration.pivot.days - previousDuration;

                            // if next stage or same stage with load order greater then current behavior modified
                            if ((stageId !== stage.id) || (stageId === stage.id && behavior.load_order > loadOrder)){
                                if (((behavior.already_completed === 1 && behavior.unlock_activity === 0) || behavior.not_available === 1) || !behavior.date) {
                                    lastDate = moment(lastDate).add(difference, 'days');
                                }else{
                                    lastDate = moment(lastDate).add(difference, 'days');
                                    behavior.date = lastDate.isValid() ? lastDate.utc(1).format('MM/DD/YYYY') : null;
                                }
                            }
                            previousDuration = duration.pivot.days;
                        }
                        return behavior;
                    })
                }
                return stage;
            })

            allBehaviors = _.filter(allBehaviors, x => x.date !== null)
            self.form.complete_date = moment(_.last(allBehaviors).date).utc(1).format('MM/DD/YYYY') ;
        },

        updateStepDate(pmContractDate) {

            const self = this;

            let lastDate = moment(pmContractDate);
            let difference = 0;
            let allBehaviors = [];

            if(self.form.pm_behaviors.length > 0) {

                let previousDuration = 0;
                self.form.pm_behaviors = _.map(self.form.pm_behaviors, (stage) => {
                    allBehaviors = _.concat(allBehaviors, stage.project_management_behaviors);
                    stage.project_management_behaviors = _.map(stage.project_management_behaviors, (behavior) => {

                        const duration = (self.form.project_duration_id) ? _.find(behavior.project_durations, x => x.id === self.form.project_duration_id) : null;

                        if(duration) {
                            difference = duration.pivot.days - previousDuration;

                            lastDate = moment(lastDate).add(difference, 'days');
                            behavior.date = lastDate.isValid() ? lastDate.utc(1).format('MM/DD/YYYY') : null;
                            previousDuration = duration.pivot.days;
                        }
                        return behavior;
                    })

                    return stage;
                })

                allBehaviors = _.filter(allBehaviors, x => x.date !== null)
                self.form.complete_date = moment(_.last(allBehaviors).date).utc(1).format('MM/DD/YYYY') ;
            }
        },

        fetchStagesByContractType() {
            let self                = this;
            this.fetching_stages    = true;
            this.pmBehaviorsExistInContractType(self.form.contract_type_id);

            axios.get(route('project-management.api.settings.codes.project-stage.index'))
                .then(({data}) => {
                    let tempPmBehaviors = data;

                    tempPmBehaviors.forEach(function (stage) {
                        stage.project_management_behaviors = _.filter(stage.project_management_behaviors, {contract_type_id: (self.existPmBehaviors ? self.form.contract_type_id : null)});
                    });

                    tempPmBehaviors.forEach(function (stage) {
                        stage.project_management_behaviors.forEach(function (behavior) {
                            let selectedBehavior = _.filter(self.project.project_behaviors, {id: behavior.id});
                            if (selectedBehavior.length > 0) {
                                behavior.user_id           = selectedBehavior[0].pivot.user_id;
                                behavior.completed         = selectedBehavior[0].pivot.completed;
                                behavior.already_completed = selectedBehavior[0].pivot.completed;
                                behavior.date              = moment(selectedBehavior[0].pivot.date).utc(1).format('MM/DD/YYYY');
                            } else {
                                behavior.user_id = null;
                                behavior.date    = null;
                            }
                        });
                    });

                    this.form.pm_behaviors = tempPmBehaviors;
                    this.fetching_stages   = false;
                    this.updateStepDate(this.form.pm_contract_date)
                });
        },

        fetchCompanies(newCompany = null) {
            axios.get(route('api.project.companies')).then(({data}) => {
                this.allCompanies = data.data;

                if (newCompany) this.handleNewCompanyp(newCompany);
            })
        },

        async fetchBehaviorHours() {
            this.behavior_hours_loading = true;
            let {data}                  = await axios.get(route('project-management.api.project.behavior-hours', {project: this.project.id}));
            this.behavior_hours         = data;
            this.behavior_hours_loading = false;
        },

        fetchContacts() {
            if (this.selectedCompany) {
                axios.get(route('api.project.company-contacts', {
                    project: this.project.id,
                    company: this.selectedCompany.id
                })).then(({data}) => {
                    this.contacts = data.data;
                });
            } else {
                this.contacts = [];
            }
        },

        fetchTeamUsers() {
            axios.get(route('api.team-users')).then(({data}) => {
                this.users = data;
            })
        },

        async fetchCodes() {
            await axios.get(route('api.project.codes')).then(({data}) => {
                this.selects = {...this.selects, ...data};
                this.pm_users  = data.pm_users;
            });
        },

        goToPage(page) {
            this.page = page;
            this.fetchComments();
        },

        fetchComments() {
            // axios.get(route('api.project-comment.index', {project: this.project.id, commentPage: this.page})).then(({data}) => {
            //     this.project_comments = data.data;
            //     this.pagination       = data;
            // });
        },

        fetchDurations() {
            axios.get(route('project-management.api.settings.codes.project-duration.index'))
                .then(({data}) => {
                    this.selects = {...this.selects, 'project_duration': data};
                });
        },

        saved(savedByComment = false) {
            const Toast = Swal.mixin({
                toast            : true,
                position         : 'top-end',
                showConfirmButton: false,
                timer            : 2000
            });

            let self = this;
            this.form.put(route('api.project-management.update', {
                project_management: this.project.project_management.id,
            })).then(() => {
                this.$refs.CustomFields.submit(self.project.id);

                Toast.fire({
                    type : 'success',
                    title: 'Your project has been updated'
                });

                setTimeout(() => {
                     window.location = route('project-management.project.edit', {projectManagement: self.project.id});
                }, 2000);
            }).catch(error => {
                this.flash(error.message, 'error');
                if (Object.keys(error.errors).length == 1 && error.errors.contract_date) {
                    const top = document.getElementById('record-details').offsetTop - document.querySelector('.navbar').offsetHeight - 5;
                    window.scrollTo({top, behavior: 'smooth'});
                }
            });
        },

        destroy() {
            let self = this;
            Swal.fire({
                title             : "Are you sure?",
                text              : "Once deleted, you will not be able to recover this project!",
                icon              : "warning",
                buttons           : true,
                showCancelButton  : true,
                confirmButtonColor: 'red',
                confirmButtonText : 'I\'m sure!',
                closeOnConfirm    : true,
                closeOnCancel     : true,
            }).then(result => {
                if (result.value) {
                    axios.delete(route('api.project-management.destroy', self.project.project_management.id)).then(() => {
                            setTimeout(() => {
                                window.location = route('api.user-mode', {
                                    'path'        : `project`,
                                    'isManagement': 0
                                });
                            }, 3000);
                        }
                    )
                }
            });
        },

        print() {
            let newwindow = window.open(`/project/print?project_id=${this.project.id}`, 'print', 'width=860,height=740,toolbar=0,menubar=0,location=0');
            if (window.focus) {
                newwindow.focus()
            }
        },

        goBack() {
            window.location = route('project-management.project.index');
        },

        removeDate(item) {
            this.$refs[item][0].clearDate();
        },

        addContact(contact) {
            this.form.company_contacts.push(contact);
        },

        removeContact(contact) {
            this.form.company_contacts = this.form.company_contacts.filter(function (addedContact) {
                return addedContact.id !== contact.id;
            });
        },

        addOrRemoveContact(contact) {
            if (this.canEdit){
                this.contactAddedAlready(contact) ? this.removeContact(contact) : this.addContact(contact);
            }
        },

        contactAddedAlready(contact) {
            return this.form.company_contacts.filter(company_contact => contact.id === company_contact.id).length > 0;
        },

        goToCompany(company) {
            window.location = route('company.show', {company: company.id});
        },

        projectCommentSaved() {
            let self = this;
            self.verifyMentionedUsers();

            if (self.company_contact) self.projectCommentForm.company_contact_id = self.company_contact.id;
            if (self.projectCommentForm.sales_status) self.projectCommentForm.sales_status_id = self.sales_status.id;

            if (self.editing) {
                self.projectCommentForm.put(route('api.project-comment.update', {projectComment: self.current_comment.id})).then((res) => {
                    $("#projectCommentModal").modal("hide");
                    self.project_comments = res.data;
                });
            } else {
                const salesStatus = this.checkIfProjectNeedsCommentBySalesStatus();

                if (salesStatus) {
                    self.projectCommentForm.sales_status_id = salesStatus.id;
                }

                self.projectCommentForm.post(route('api.project-comment.store', {project: self.project.id})).then((res) => {
                    self.saved(true);
                    $("#projectCommentModal").modal("hide");
                    self.project_comments = res.data;
                });
            }
        },

        newContactSaved() {
            let self = this;
            self.newContactForm.post(route('api.contact.store', {company: self.selectedCompany.id})).then((res) => {
                $("#newContactModal").modal("hide");
                self.fetchContacts()
            });
        },

        addComment(contact = null) {
            $("#projectCommentModal").modal("show");
            if (contact) this.company_contact = contact;
        },

        addNewContact() {
            this.newContactForm.reset();
            $("#newContactModal").modal("show");
        },

        editComment(comment) {
            $("#projectCommentModal").modal("show");
            this.current_comment = comment;
            this.editing         = true;
            if (comment.company_contact) this.company_contact = comment.company_contact;
            if (comment.sales_status) this.sales_status = comment.sales_status;
            Object.assign(this.projectCommentForm, comment);
        },

        addPinComment(comment) {
            const Toast = Swal.mixin({
                toast            : true,
                position         : 'top-end',
                showConfirmButton: false,
                timer            : 2000
            });

            let self = this;
            Swal.fire({
                title             : "Are you sure?",
                text              : "Do you want to pin this comment?",
                icon              : "warning",
                buttons           : true,
                dangerMode        : false,
                showCancelButton  : true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText : 'I\'m sure!',
                closeOnConfirm    : true,
                closeOnCancel     : true,
            }).then(result => {
                if (result.value) {
                    axios.put(route('api.project-comment.add-pin', {projectComment: comment.id})).then(({data}) => {

                        self.project_comments = data.data;

                        const Toast = Swal.mixin({
                            toast            : true,
                            position         : 'top-end',
                            showConfirmButton: false,
                            timer            : 2000
                        });
                        Toast.fire({
                            type : "success",
                            title: "Your comment has been pinned."
                        });
                    });
                }
            });
        },

        removePinComment(comment) {
            const Toast = Swal.mixin({
                toast            : true,
                position         : 'top-end',
                showConfirmButton: false,
                timer            : 2000
            });

            let self = this;
            Swal.fire({
                title             : "Are you sure?",
                text              : "Do you want to remove pin?",
                icon              : "warning",
                buttons           : true,
                dangerMode        : false,
                showCancelButton  : true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText : 'I\'m sure!',
                closeOnConfirm    : true,
                closeOnCancel     : true,
            }).then(result => {
                if (result.value) {
                    axios.put(route('api.project-comment.remove-pin', {projectComment: comment.id})).then(({data}) => {

                        self.project_comments = data.data;

                        const Toast = Swal.mixin({
                            toast            : true,
                            position         : 'top-end',
                            showConfirmButton: false,
                            timer            : 2000
                        });
                        Toast.fire({
                            type : "success",
                            title: "Pin has removed."
                        });
                    });
                }
            });
        },

        removeComment(comment) {
            let self = this;
            Swal.fire({
                title             : "Are you sure?",
                text              : "Once deleted, you will not be able to recover this comment!",
                icon              : "warning",
                buttons           : true,
                dangerMode        : true,
                showCancelButton  : true,
                confirmButtonColor: '#17252A',
                confirmButtonText : 'I\'m sure!',
                closeOnConfirm    : true,
                closeOnCancel     : true,
            }).then(result => {
                if (result.value) {
                    axios.delete(route('api.project-comment.delete', {projectComment: comment.id})).then(() => {
                        window.location = route('project-management.project.edit', {project: self.project.id});
                    });
                }
            });
        },

        addMention(replaced) {
            this.projectCommentForm.mentioned_users.push(replaced.id);
        },

        filterUsers(mentionText, cb) {
            const users = _.filter(this.users, (user) => user.name.toLowerCase().indexOf(mentionText.toLowerCase()) !== -1);
            cb(users.slice(0, 5));
        },

        verifyMentionedUsers() {
            this.projectCommentForm.mentioned_users = _.filter(this.projectCommentForm.mentioned_users, user_id => {

                const user = this.users.find(function (el) {
                    return el.id == user_id;
                });

                if (!user)
                    return false;

                return this.projectCommentForm.comment.indexOf('@</span>' + user.name) !== -1;
            });
        },

        removeMeeting(index) {
            this.form.company_contacts[index].date      = null;
            this.form.company_contacts[index].completed = null;
        },

        openEmailModal(sales_behavior) {
            var project = {
                name    : this.form.name,
                id      : this.project.id,
                location: this.form.address,
                contact: this.project.contact
            }
            this.$refs.EmailFileModal.open(sales_behavior, project);
        },

        openEmailContactModal() {
            this.$refs.EmailContactModal.open(this.project.id);
        },

        openCompanyContactModal(contact, index) {
            this.$refs.companyContactModal.open(contact, index);
        },

        saveContactData(contact) {
            this.form.company_contacts[contact.index].date      = contact.date;
            this.form.company_contacts[contact.index].completed = contact.completed;
            this.form.company_contacts[contact.index].status    = contact.status;
        },

        checkProposalDelivered(salesBehavior) {
            if (salesBehavior.proposal_delivered === 1 && salesBehavior.completed == 1 && !this.form.bid_date) {
                this.form.bid_date = salesBehavior.date;
            }
        },

        findActiveProposalDelivered() {
            const sb                        = _.find(this.project.sales_behaviors, {
                completed         : 1,
                proposal_delivered: 1
            });
            this.checked_proposal_delivered = sb ? sb.id : null;
        },

        getLocalCurrentListData() {
            this.storage_project_list.list          = localStorage.getItem('current_project_list_project_management') ?
                JSON.parse(localStorage.getItem('current_project_list_project_management')).data ?? JSON.parse(localStorage.getItem('current_project_list_project_management')) :
                [];
            this.storage_project_list.current_index = this.storage_project_list.list.indexOf(this.project.id);
        },

        changeProject(to) {
            if (to === 'previous' && this.storage_project_list.current_index !== 0) {
                window.location.href = `/project-management/project/${this.storage_project_list.list[this.storage_project_list.current_index - 1]}/edit?project=1`;
            } else if (to === 'next' && this.storage_project_list.current_index !== this.storage_project_list.list.length - 1) {
                window.location.href = `/project-management/project/${this.storage_project_list.list[this.storage_project_list.current_index + 1]}/edit?project=1`;
            }
        },

        openCompanyCreateModal(name) {
            this.$refs.CompanyCreateModal.open(name);
        },

        async handleNewCompany(company) {
            this.selectedCompany = _.find(this.allCompanies, {id: company.id});
            this.fetchContacts();
        },

        checkIfProjectNeedsCommentBySalesStatus() {
            const oldSales = _.find(this.selects.sales_status, {id: this.project.sales_status});
            const newSales = _.find(this.selects.sales_status, {id: this.form.sales_status_id}) || {};

            return newSales && (!this.project.sales_status || oldSales.id !== newSales.id) && newSales.comment ? newSales : null;
        },

        removeNewContactDate() {
            this.newContactForm.date = null;
        },

        openNewCompanyContactModal() {
            this.$refs.CompanyContactModal.open();
        },

        parseContact(contact) {
            this.newContactForm.name  = contact.name;
            this.newContactForm.cell  = contact.phone;
            this.newContactForm.email = contact.email;
        },

        changeUserBehavior(userId, assignedTo) {
            const vue = this;
            this.form.pm_behaviors.forEach(function (stage) {
                stage.project_management_behaviors.forEach(function (behavior) {
                    if (behavior.assigned_to == assignedTo && !behavior.already_completed) {
                        behavior.userObj = {
                            id: userId,
                            name: vue.pm_users.find(x => x.id === userId)?.name

                        };
                    }
                });
            });
        },

        addCrewLeader() {
            this.form.crew_leaders.push({
                user_id   : 0,
                start_date: moment().format('MM/DD/YYYY'),
                end_date  : moment().format('MM/DD/YYYY'),
            });
        },

        removeCrewLeader(index) {
            this.form.crew_leaders.splice(index, 1);
        },
        uploadProjectStartEndDate(){
            axios.post(route('api.project-management.unlock-project-start-end-date'), {
                project_management: this.project.project_management.id,
            }).then((response) => {
                this.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                setTimeout( window.location.reload(), 1000);
            });
        },
        fixDate(event){
            return moment(event).format('MM/DD/yyyy');
        },
        removeUserFromConstructionBehavior(constructionIndex, index){
            console.log(constructionIndex, index);
            this.$nextTick(() => {
                this.form.pm_behaviors[index].project_management_behaviors[constructionIndex].userObj = {
                    id: null,
                    name: ""
                }
            })
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.tribute-container {
    z-index: 2000;
    margin: 0.4rem 0 0 0.9rem;
    background-color: #ffffff;
    border: 0.5px solid #dae7e7;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
    -webkit-border-radius: 0.1rem;
    -moz-border-radius: 0.1rem;
    border-radius: 0.1rem;

    ul {
        padding: 0;

        li {
            list-style-type: none;
            cursor: pointer;
            color: black;
            width: 100%;
            text-align: left;
            padding: 0.3rem 3rem 0.3rem 0.7rem;
            border-top: 0.1px solid #dae7e7;
        }
    }
}

.selected-mention {
    background-color: #17252a;
    color: white !important;
}

.vdp-datepicker {
    &.fullscreen-when-on-mobile {
        @media (max-width: 767px) {
            position: static;
            .vdp-datepicker__calendar {
                position: fixed;
                top: 50%;
                left: 5%;
                margin-top: -25%;
                width: 90%;
                z-index: 2000;
                outline: rgba(0, 0, 0, 0.5) solid 9999px;
            }
        }
    }

    .cell {
        &.today {
            background-color: rgb(220, 245, 252);
        }
    }
}

.sales-behavior-checkbox {
    width: 1.3rem;
    height: 1.3rem;
}

.ql-editor {
    background-color: #fff;
    min-height: 200px;
}
.my-display-contents{
    display: contents;
}
.my-unlock-button-dates{
    display: flex;
    align-items: center;
    padding-left: 20px !important;
}
.width-36{
    width:36%;
}
#project-management-form-id input[type="text"]:disabled {
    background: #f5f5f5;
}
</style>
